var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCabina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 61,
    viewBox: "0 0 80 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.412 0.782696C16.1264 1.75048 11.7342 4.13271 7.93753 7.92939C0.716393 15.1505 -0.251388 19.6172 0.0463906 45.7473L0.120835 60.6362H33.5465H66.9722L70.2477 58.924C76.65 55.4995 79.9256 50.0651 80 42.9184C80 35.6228 76.5755 30.1139 69.95 27.0617C66.7488 25.4983 65.0366 25.275 57.8899 25.275H49.4777V15.5972C49.4777 4.80271 48.8821 2.7927 45.3832 1.08047C42.6288 -0.185085 27.2187 -0.408421 21.412 0.782696ZM38.6087 11.5772C38.8321 12.2472 39.0554 15.5227 39.0554 18.8728V25.0517L25.2087 31.1561C17.6153 34.4317 11.1387 37.1862 10.692 37.1862C9.7242 37.1862 9.87309 23.0417 10.9153 19.9894C12.032 16.565 14.1164 14.0339 17.3176 12.0983C19.7742 10.6094 21.0398 10.3861 29.0798 10.3861C36.6732 10.3861 38.2365 10.6094 38.6087 11.5772Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabina);
export default __webpack_public_path__ + "static/media/cabina.92d7621d03bca7b2a719b21b02f61514.svg";
export { ForwardRef as ReactComponent };